<div class="account-settings-user-access-container">
    <!-- Header Section -->
    <div class="header-section">
        <div class="header-actions" *ngIf="!isNoAdminUser">
            <button 
                type="button" 
                class="btn btn-primary create-admin-btn" 
                [disabled]="!isUserHasWriteAccess"
                (click)="openAddAdminPanel()">
                New Admin
            </button>
        </div>
    </div>

    <!-- Admin List Section -->
    <div class="admin-list-section" *ngIf="managers.length > 0 || isPageBusy">
        <div class="admin-list">
            <div class="admin-item" *ngFor="let manager of managers; trackBy: trackByManagerId">
                <div class="admin-card" [class.expandable]="manager.manager_access && manager.manager_access.length > 1">
                    <div class="admin-main-info" (click)="toggleManagerExpansion(manager)">
                        <div class="admin-icon">
                            <i class="fa fa-user"></i>
                        </div>
                        <div class="admin-details">
                            <div class="admin-email">{{ manager.email_address || 'NA' }} | 
                                <span class="status-badge" 
                                      [class.verified]="manager.manager_access && manager.manager_access[0]?.is_verified"
                                      [class.not-verified]="!manager.manager_access || !manager.manager_access[0]?.is_verified">
                                    {{ manager.manager_access && manager.manager_access[0]?.is_verified ? 'Verified' : 'Not Verified' }}
                                </span>
                            </div>
                            <div class="admin-meta">
                                <span class="created-by" [title]="getCreatorName(manager)">Added by {{ getCreatorName(manager) }}</span>
                                <span class="separator">|</span>
                                <span class="created-date">Added on {{ getCreatedDate(manager) }}</span>
                            </div>
                        </div>
                        <div class="admin-actions">
                            <button 
                                class="delete-btn" 
                                [disabled]="!isUserHasWriteAccess || manager._id == loggedInManagerId"
                                (click)="prepareToRemoveAccess(manager.email_address, manager._id, 'account', accountName, manager.manager_access[0]?.account_id); $event.stopPropagation()"
                                title="Revoke Access">
                                <i class="fa fa-trash"></i>
                            </button>
                            <span class="expand-icon" *ngIf="manager.manager_access && manager.manager_access.length > 1">
                                <i class="fa" [class.fa-caret-down]="!manager.isCollapsed" [class.fa-caret-up]="manager.isCollapsed"></i>
                            </span>
                        </div>
                    </div>

                    <!-- Expanded project-level access (commented out as in LW2) -->
                    <!-- <div class="admin-projects" *ngIf="manager.isCollapsed && manager.manager_access && manager.manager_access.length > 1">
                        <div class="project-item" *ngFor="let brand of manager.manager_access" >
                            <div class="project-name" *ngIf="brand.manager_type == 2">
                                {{ brands_name[brand.brand_id] || 'NA' }}
                            </div>
                            <button 
                                class="delete-btn-small" 
                                *ngIf="brand.manager_type == 2"
                                (click)="prepareToRemoveAccess(manager.email_address, manager._id, 'brand', brands_name[brand.brand_id], brand.brand_id)"
                                title="Remove Project Access">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </div> -->
                </div>
            </div>

            <!-- Loading Indicator -->
            <div class="loading-section" *ngIf="isPageBusy">
                <div class="spinner"></div>
                <p>Loading admins...</p>
            </div>

            <!-- All Data Loaded Message -->
            <div class="info-message" *ngIf="isNoMoreData && managers.length > 0">
                <p>All admins have been loaded.</p>
            </div>

            <!-- Load More Button -->
            <div class="load-more-section" *ngIf="!isNoMoreData && !isPageBusy && managers.length > 0">
                <button class="btn btn-secondary load-more-btn" (click)="getAdminManagers()">
                    <i class="fa fa-arrow-down"></i> Load More
                </button>
            </div>
        </div>
    </div>

    <!-- No Data Message -->
    <div class="no-data-section" *ngIf="isNoAdminUser && !isPageBusy || isNoAccountAccess">
        <!-- <div class="no-data-icon">
            <i class="fa fa-users"></i>
        </div> -->
        <div class="no-account-access" *ngIf="isNoAccountAccess">
            <p class="no-data-text">Your account does not have the required permissions.</p>
        </div>
        <div *ngIf="isNoAdminUser && !isPageBusy">
        <p class="no-data-text">No admin users created.</p>
        <button class="btn btn-primary" [disabled]="!isUserHasWriteAccess" (click)="openAddAdminPanel()">
            Add First Admin
        </button>
    </div>
    </div>
</div>

<!-- User Form Panel (Sidebar) -->
<app-user-form-panel 
    [accountId]="accountId"
    [canWrite]="isUserHasWriteAccess"
    (closePanel)="onAdminCreated()"
    (adminCreated)="onAdminCreated()">
</app-user-form-panel>

<!-- Revoke Access Confirmation Modal -->
<div class="revoke-modal-overlay" *ngIf="showRevokeModal" (click)="closeRevokeModal()">
    <div class="revoke-modal" (click)="$event.stopPropagation()">
        <div class="modal-content">
            <div *ngIf="revokeDetails.type === 'account'">
                <h4>Are you sure you want to proceed?</h4>
                <p>Click on 'Yes' to delete all user access permissions for <strong>{{ revokeDetails.email_address }}</strong> in <strong>{{ accountName }}</strong></p>
                <p class="warning-text">Please note that the access permissions across all projects of this account will also be deleted.</p>
            </div>
            <div *ngIf="revokeDetails.type === 'brand'">
                <h4>Are you sure you want to proceed?</h4>
                <p>Click on "Yes" to delete the user access associated with <strong>{{ revokeDetails.brand_name }}</strong></p>
            </div>
        </div>
        <div class="modal-actions">
            <button class="btn btn-secondary" (click)="closeRevokeModal()">Cancel</button>
            <button class="btn btn-danger" (click)="removeAccess()">Yes</button>
        </div>
    </div>
</div>
